var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestedVisit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 144,
    viewBox: "0 0 161 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1606_8454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.831 5H41.944L3 72.453L41.944 139.905H119.831L158.774 72.453L119.831 5Z",
    fill: "#B3D336",
    stroke: "#EAEAEA",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 49.1811H33.8189V49C33.8189 49 33.8189 48 33.5 48C33.1811 48 33.1811 49 33.1811 49V49.1811H33C33 49.1811 32 49.1811 32 49.5C32 49.8189 33 49.8189 33 49.8189H33.1811V50C33.1811 50 33.1811 51 33.5 51C33.8189 51 33.8189 50 33.8189 50V49.8189H34C34 49.8189 35 49.8189 35 49.5C35 49.1811 34 49.1811 34 49.1811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.5,
    cy: 14.5,
    r: 2.25,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 112.5,
    r: 1.25,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 95,
    r: 1.75,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 66.5,
    r: 2.25,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9458 22.3301H58.5885V21.9728C58.5885 21.9728 58.5885 20 57.9593 20C57.3301 20 57.3301 21.9728 57.3301 21.9728V22.3301H56.9728C56.9728 22.3301 55 22.3301 55 22.9593C55 23.5884 56.9728 23.5885 56.9728 23.5885H57.3301V23.9457C57.3301 23.9457 57.3301 25.9186 57.9593 25.9186C58.5885 25.9186 58.5885 23.9457 58.5885 23.9457V23.5885H58.9457C58.9457 23.5885 60.9186 23.5884 60.9186 22.9593C60.9186 22.3301 58.9458 22.3301 58.9458 22.3301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.667 90.1653H131.335V89.8333C131.335 89.8333 131.335 88 130.75 88C130.165 88 130.165 89.8333 130.165 89.8333V90.1653H129.833C129.833 90.1653 128 90.1653 128 90.75C128 91.3346 129.833 91.3347 129.833 91.3347H130.165V91.6667C130.165 91.6667 130.165 93.5 130.75 93.5C131.335 93.5 131.335 91.6667 131.335 91.6667V91.3347H131.667C131.667 91.3347 133.5 91.3347 133.5 90.75C133.5 90.1653 131.667 90.1653 131.667 90.1653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.333 48.1496H124.85V47.6666C124.85 47.6666 124.85 45 124 45C123.15 45 123.15 47.6666 123.15 47.6666V48.1496H122.667C122.667 48.1496 120 48.1496 120 49C120 49.8504 122.667 49.8504 122.667 49.8504H123.15V50.3334C123.15 50.3334 123.15 53 124 53C124.85 53 124.85 50.3334 124.85 50.3334V49.8504H125.333C125.333 49.8504 128 49.8504 128 49C128 48.1495 125.333 48.1496 125.333 48.1496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.567 27.5157H109.334V27.2833C109.334 27.2833 109.334 26 108.925 26C108.516 26 108.516 27.2833 108.516 27.2833V27.5157H108.283C108.283 27.5157 107 27.5157 107 27.925C107 28.3342 108.283 28.3343 108.283 28.3343H108.516V28.5667C108.516 28.5667 108.516 29.85 108.925 29.85C109.334 29.85 109.334 28.5667 109.334 28.5667V28.3343H109.567C109.567 28.3343 110.85 28.3343 110.85 27.925C110.85 27.5157 109.567 27.5157 109.567 27.5157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6667 122.756H61.2441V122.333C61.2441 122.333 61.2441 120 60.5 120C59.7559 120 59.7559 122.333 59.7559 122.333V122.756H59.3333C59.3333 122.756 57 122.756 57 123.5C57 124.244 59.3333 124.244 59.3333 124.244H59.7559V124.667C59.7559 124.667 59.7559 127 60.5 127C61.2441 127 61.2441 124.667 61.2441 124.667V124.244H61.6667C61.6667 124.244 64 124.244 64 123.5C64 122.756 61.6667 122.756 61.6667 122.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.333 119.968H107.032V119.667C107.032 119.667 107.032 118 106.5 118C105.968 118 105.968 119.667 105.968 119.667V119.968H105.667C105.667 119.968 104 119.968 104 120.5C104 121.031 105.667 121.032 105.667 121.032H105.968V121.333C105.968 121.333 105.968 123 106.5 123C107.032 123 107.032 121.333 107.032 121.333V121.032H107.333C107.333 121.032 109 121.032 109 120.5C109 119.968 107.333 119.968 107.333 119.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.28 78.1181H28.8019V77.64C28.8019 77.64 28.8019 75 27.96 75C27.1181 75 27.1181 77.64 27.1181 77.64V78.1181H26.64C26.64 78.1181 24 78.1181 24 78.96C24 79.8019 26.64 79.8019 26.64 79.8019H27.1181V80.28C27.1181 80.28 27.1181 82.92 27.96 82.92C28.8019 82.92 28.8019 80.28 28.8019 80.28V79.8019H29.28C29.28 79.8019 31.92 79.8019 31.92 78.96C31.92 78.118 29.28 78.1181 29.28 78.1181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M118.5 136.5L152 79.5L111.5 44.5L48.5 110.5",
    fill: "#84A304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.407 112H52.8131C49.0505 112 46 108.95 46 105.187V49.1461C46 45.3835 49.0505 42.333 52.8131 42.333H109.407C113.17 42.333 116.22 45.3835 116.22 49.1461V105.187C116.22 108.95 113.17 112 109.407 112Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7946 99.5893C73.1881 99.5893 67 93.4011 67 85.7947C67 78.1882 73.1883 72 80.7946 72C88.401 72 94.5893 78.1882 94.5893 85.7947C94.5893 93.4011 88.401 99.5893 80.7946 99.5893Z",
    fill: "#B4E103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8496 89.7371C76.2741 89.1617 76.2741 88.2287 76.8496 87.6532L79.3187 85.1841V79.8486C79.3187 79.0348 79.9785 78.375 80.7923 78.375C81.6061 78.375 82.2659 79.0348 82.2659 79.8486V85.7945C82.2659 86.1854 82.1107 86.5602 81.8342 86.8365L78.9335 89.7372C78.358 90.3126 77.4249 90.3127 76.8496 89.7371Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7955 72C80.7816 72 80.7678 72.0005 80.7539 72.0005V99.5887C80.7678 99.5887 80.7816 99.5892 80.7955 99.5892C88.402 99.5892 94.5902 93.401 94.5902 85.7945C94.5902 78.1881 88.4019 72 80.7955 72Z",
    fill: "#B2D235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.795 78.375C80.7811 78.375 80.7677 78.3767 80.7539 78.377V87.9193L81.8369 86.8363C82.1134 86.56 82.2686 86.1852 82.2686 85.7944V79.8487C82.2685 79.0347 81.6087 78.375 80.795 78.375Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.295 42.332H102.66C106.423 42.332 109.473 45.3825 109.473 49.1452V105.186C109.473 108.949 106.423 111.999 102.66 111.999H109.295C113.058 111.999 116.108 108.949 116.108 105.186V49.1453C116.108 45.3823 113.058 42.332 109.295 42.332Z",
    fill: "#E1E1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.111 63.6633H45.8906V49.1299C45.8906 45.376 48.9336 42.333 52.6875 42.333H109.314C113.068 42.333 116.111 45.376 116.111 49.1299V63.6633Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.68 42.332H109.315C113.068 42.332 116.111 45.3752 116.111 49.1291V63.6625H109.476V49.1291C109.476 45.3752 106.433 42.332 102.68 42.332Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2391 51.352C61.0252 51.352 59.2305 49.5572 59.2305 47.3434V36.0086C59.2303 33.7948 61.0252 32 63.2391 32C65.453 32 67.2477 33.7948 67.2477 36.0086V47.3433C67.2477 49.5572 65.4528 51.352 63.2391 51.352Z",
    fill: "#004C74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0711 51.352C95.8572 51.352 94.0625 49.5572 94.0625 47.3434V36.0086C94.0625 33.7948 95.8572 32 98.0711 32C100.285 32 102.08 33.7948 102.08 36.0086V47.3433C102.08 49.5572 100.285 51.352 98.0711 51.352Z",
    fill: "#004C74"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1606_8454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160.774,
    height: 143.01,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestedVisit);
export default __webpack_public_path__ + "static/media/RequestedVisit.43f17d82.svg";
export { ForwardRef as ReactComponent };